// Borrowed from https://github.com/formium/formik/issues/1484#issuecomment-657047521

import {useFormikContext} from 'formik';
import {useEffect, useState} from 'react';

export function useSubmitValidationErrorHandler(
  onSubmitError: () => void
): void {
  const [lastHandled, setLastHandled] = useState(0);
  const {submitCount, isValid, isSubmitting} = useFormikContext();

  useEffect(() => {
    if (submitCount > lastHandled && !isSubmitting && !isValid) {
      onSubmitError();
      setLastHandled(submitCount);
    }
  }, [submitCount, isValid, onSubmitError, lastHandled, isSubmitting]);
}
